import React, { useState } from 'react'
import "./ChangePassword.scss"
import Laptop from "../../assets/img/laptop.png"
import ModalPassword from '../../components/Modales/Password/ModalPassword'
import { Modal } from "react-bootstrap"
import { Oval } from 'react-loader-spinner'
import { useNavigate } from 'react-router-dom';

function ValidateMail() {

  const navigate = useNavigate()

  const [error, setError] = useState(null)
  const [fetchError, setFetchError] = useState(null)
  const [email, setEmail] = useState("")
  const [errors, setErrors] = useState({})
  const [modalError, setModalError] = useState(false)

  const [modalPassword, setModalPassword] = useState(false)
  const [activated, setActivated] = useState(false);
  const [objData, setObjData] = useState(null);
  const [sendCode, setSendCode] = useState(false)

  const [loading, setLoading] = useState(false)

  const validateForm = (data) => {
    const errors = {}
    if(!data.trim()){
      errors.email = "Escriba el mail."
    } else if (!/\S+@\S+\.\S+/.test(data)){
      errors.email = "El email no es válido."
    }
    return errors;
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const newErrors = validateForm(email)
    setErrors(newErrors)
    if(Object.keys(newErrors).length === 0){
      setError(null)
      try {
        setLoading(true)
        const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/validarMail`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json"
          },
          body: JSON.stringify({
            mailUser: email
          })
        })
        const data = await res.json()
        const errorCode = data.error ?? data.status
        if(errorCode !== 0){
          setError(data.errorDetalle || data.codeError)
          setLoading(false)
          // SI EL USUARIO TIENE ACTIVO 2FA
        } else if (data.objeto?.["2FA"] === true){
          setActivated(true)
          // Necesita el id del user
          setObjData({
            id: data.objeto.idUser
          })
          setModalPassword(true)
          setLoading(false)
          // SI EL USUARIO NO TIENE ACTIVO 2FA
        } else if (data.objeto?.["2FA"] === false){
          try {
            setLoading(true)
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/recupera/enviarMail`, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                mailUser: email
              })
            })
            const dataMail = await res.json()
            const dataCode = dataMail.error ?? dataMail.status
            if(dataCode !== 0){
              setError(dataMail.errorDetalle || dataMail.codeError)
              setLoading(false)
            } else {
              setSendCode(true)
              setModalPassword(true)
              setLoading(false)
            }
          } catch (error) {
            setLoading(false)
            setFetchError("Error en el backend. Intenta nuevamente.")
            setModalError(true)
          }
        }
      } catch (error) {
        setLoading(false)
        setFetchError("Error en el backend. Intenta nuevamente.")
        setModalError(true)  
      }
      
    } else {
      setError("Completar los campos mencionados.")
    }
  }

  return (
    <>
      {modalError && <Modal show={modalError} onHide={()=>setModalError(false)} animation={false}>
          <Modal.Header closeButton>
              <Modal.Title>¡Ha ocurrido un problema!</Modal.Title>
          </Modal.Header>
          <Modal.Body>{fetchError}</Modal.Body>
        </Modal>
      }
      {modalPassword && 
        <ModalPassword 
          show={modalPassword}
          onClose={()=>setModalPassword(false)}
          objData={objData}
          email={email}
          activated={activated}
          sendCode={sendCode}
          onSuccess={()=>{
            setLoading(false)
            setModalPassword(false)
            navigate("/change-password", { state: { email } })
          }}
          onError={(msj) => {
            setLoading(false)
            setFetchError(msj)
            setModalError(true)
          }}
        />
      }
      {/* Loading */}
      {loading && <div className='loading vh-100 vw-100 z-3 position-absolute d-flex flex-column align-items-center justify-content-center'>
          <Oval
              visible={true}
              height="80"
              width="80"
              color="#fff"
              ariaLabel="oval-loading"
              wrapperStyle={{}}
              wrapperClass=""
          />
          <p className='text-white fw-medium'>Loading...</p>
      </div>}
      <div className='validateMail vh-100 d-flex align-items-center justify-content-center'>
        <div className='validateMail__form bg-white d-flex flex-column align-items-center justify-content-center shadow-sm rounded-3'>
          <img className='mb-4' src={Laptop} alt='Usuario'/>
          <h3 className='text-blue-500 fw-medium text-center mb-2'>Recuperación de contraseña</h3>
          <p className='m-0 mb-4 text-center'>Ingresa el correo electrónico que usas para entrar a <span className='fw-medium text-blue-500'>kiviu.com</span></p>
          <form className='w-100 d-flex flex-column align-items-center' onSubmit={handleSubmit}>
            <div className="w-100 d-flex flex-column mb-4">
              <label htmlFor="email" className="form-label">Correo</label>
              <input 
                onChange={(e)=>setEmail(e.target.value)} 
                type="email" 
                id="email" 
                name="email" 
                placeholder="ejemplo@correo.com.ar" 
                className="form-control"
                value={email}
              />
              {errors.email && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.email}</span>}
            </div>
            {error !== null && <div className='mb-2 form__error'><i className="bi bi-exclamation-circle pe-2 text-danger"></i><span className='text-danger'>{error}</span></div>}
            <button type='submit' className='btn btn-primary rounded-pill fw-medium px-4'>Enviar correo de restauración</button>
          </form>
        </div>
      </div>
    </>
  )
}

export default ValidateMail